import React from 'react';
import Row from '../general/Row';
import Column from '../general/Column';
import styled from 'styled-components';

const ServiceCenterInfo = styled.div`
  height: 500px;
  overflow-y: auto;
  margin-bottom: 2rem;
  
  .service-center-profile-name {
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    margin-bottom: 0;
  }
  
  .service-center-meta {
    margin-top: 1rem;
  }

  .service-center-profile-address {
    margin: 0;
    font-size: 14px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
  }

  .service-center-profile-phone {
    font-size: 14px;
    color: #038cca;
  }

  .service-center-services {
    margin: 0;
    font-size: 14px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    display: block;
  }

  .result-numbers {
    display: flex;
    justify-content: center;
  }

`;

const ServiceCentersResultsList = ({ results }: { results: any }) => {
  return (
    <Row>
      <ServiceCenterInfo id="service-centers-result-list">
        <span className='result-numbers'>{results.data.total} Results:</span>
        {results.data.results.map((result: any, index: number) => (
          <div className="service-center-tile" key={index}>
            <div className="row no-gutters">
              <Column>
                <div className="service-center-meta">
                  <h4 className="service-center-profile-name">{result.name}</h4>
                  <div className="service-center-profile-meta">
                    <div className="service-center-profile-address">
                      {result.street}<br />
                      {result.city}, {result.state} {result.postal}
                    </div>
                    <div className="service-center-profile-phone">
                      <span><a className="storelocator-phone" href={"tel:" + result.phone}>{result.phone}</a></span>
                    </div>
                    <div className="service-center-popup-controls">
                      <span className="service-center-profile-directions">
                        <a href={"https://maps.google.com?saddr=Current+Location&daddr=" + result.street + result.city + result.state} target="_blank">Directions</a>
                      </span>
                    </div>
                    <div className="service-center-services">
                      <strong>Services:</strong> {/* Header for Services */}
                      {Object.keys(result.services).map((service, i, arr) => (
                          result.services[service] && (
                            <div key={i}>
                              {service}{i !== arr.length - 1 ? ', ' : ''}
                            </div>
                          )
                        ))}
                    </div>
                  </div>
                </div>
              </Column>
            </div>
          </div>
        ))}
      </ServiceCenterInfo>
    </Row>
  );
};

export default ServiceCentersResultsList;